import { omit } from 'lodash'

export const normalizeFetchProblemSetsResponse = response =>
    response.map(problemSet => ({
        id: problemSet.problem_set.id,
        name: problemSet.problem_set.name,
        problemsCount: problemSet.problems_count,
        firstProblemToken: problemSet.first_problem_token,
    }))

export const normalizeFetchProblemSetDetailsResponse = response => ({
    id: response.problem_set.id,
    name: response.problem_set.name,
    instructions: response.problem_set.instructions,
    problems: response.problems.map(problem => ({
        id: problem.assignment_id,
        name: problem.assignment_name,
    })),
})

export const normalizeFetchAttachableProblemsResponse = response =>
    response.map(problem => ({
        id: problem.id,
        name: problem.name,
        token: problem.token,
        defaultLayerId: problem.default_layer_id,
    }))

export const normalizeFetchProblemSetProblemsResponse = response => ({
    instructions: response.instructions,
    problems: response.problems.map(problem => ({
        id: problem.assignment_id,
        name: problem.assignment_name,
        token: problem.assignment_token,
        grade: problem.grade,
        maxGrade: problem.max_grade_for_assignment,
        hasAccess: problem.has_access,
    })),
})

export const normalizeFetchProblemSetGradesResponse = response => ({
    submissions: response.submissions.map(submission => ({
        name: submission.file_name,
        problems: Object.keys(omit(submission, 'file_name')).map(key => ({
            name: key,
            grade: submission[key],
        })),
    })),
    totalPages: response.total_pages,
})
